<ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="
{
  allFeeBasedServices: (allFeeBasedServices$ | async)
}">

</ng-container>

<ng-template #template let-allFeeBasedServices="allFeeBasedServices">
  <form [formGroup]="formGroup" formSanitizer (ngSubmit)="onSave()">
    <div mat-dialog-title>
      <h1 mat-dialog-title *ngIf="data.mode === 'add'">New service fee</h1>
      <h1 mat-dialog-title *ngIf="data.mode === 'edit'">Edit service fee</h1>
    </div>
    <mat-dialog-content flexLayout="row" flexLayoutAlign="start center" flexLayoutGap="1rem">

      <mat-form-field flex>
        <mat-label>Fee Based Service</mat-label>
        <mat-select required formControlName="friendlyId">
          <mat-option *ngFor="let service of allFeeBasedServices" [value]="service.friendlyId">
            {{ service.displayName }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field flex>
        <mat-label>Fee</mat-label>
        <input title="Fee" matInput required type="number" formControlName="fee" />
      </mat-form-field>

    </mat-dialog-content>
    <mat-dialog-actions flexLayout="row" flexLayoutAlign="space-between center">
      <div flexLayout="row" flexLayoutAlign="start center">
        <mat-slide-toggle [formControlName]="'active'" [color]="'accent'" class="mb-3">Active</mat-slide-toggle>
      </div>

      <div flexLayout="row" flexLayoutAlign="end center">
        <button type="button" mat-flat-button (click)="onCancel()">Cancel</button>
        <button type="submit" mat-raised-button color="primary" [disabled]="formGroup.invalid">
          Commit
        </button>
      </div>
    </mat-dialog-actions>
  </form>
</ng-template>
